/**
 * Shape of `AiAnimatedElementPreset.modelData.jsonPromptObject`.
 *
 * The GraphQL schema declares this as a `JSON` scalar, which codegen emits as
 * `any`. These are the only keys this app reads; both are optional because the
 * object is authored per preset.
 */
export interface PresetPromptObject {
  background_image_prompt?: string;
  input_prompt?: string;
}

/** Narrows the untyped `JSON` scalar to the keys this app reads. */
export function presetPromptObject(
  jsonPromptObject: unknown,
): PresetPromptObject | undefined {
  return jsonPromptObject ?? undefined;
}
